import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import { ToastContainer, toast } from 'react-toastify';
import SweetAlert from "sweetalert2";
import { ColumnsType } from 'antd/es/table';

// Modèles et utilitaires
import Data from '../../../../Data/Data.json';
import { Crypter } from '../../../../Functions/Security/Crypter';
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import Utilisateur from '../../../../Models/Utilisateur';
import DatatEod from '../../../../Models/DataEod';
import CaisseEOD from '../../../../Models/CaisseEOD';
import DataHistoCpt from '../../../../Types/DataHistoCpt';

// Composants Design System
import { DashboardContainer } from '../../../DayProcess/DashboardContainer';
import { DashboardHeader } from '../../../DayProcess/DashboardHeader';
import { StatisticsCards } from '../../../DayProcess/StatisticsCards';
import { ActionBar } from '../../../DayProcess/ActionBar';
import { BranchStatusBadge, CaisseStatusBadge, IndicatorBadge } from '../../../DayProcess/StatusBadge';
import { AgencyTable } from '../../../DayProcess/AgencyTable';
import { DetailsModal } from '../../../DayProcess/DetailsModal';
import { Box } from '@mui/material';
import { Badge } from 'antd';

const FermetureJournee = () => {
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
  const authHeader = useAuthHeader();

  // États métier
  const [DatatEod, setDatatEod] = useState<DatatEod[]>([]);
  const [AgenceC, SetAgenceC] = useState<string[]>([]);
  
  // États UI
  const [loading1, setLoading1] = useState(false);
  const [loadP, setLoadP] = useState(false);
  const [progress, setProgress] = useState(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  
  // États modale
  const [Open, SetOpen] = useState<boolean>(false);
  const [data, Setdata] = useState<any[]>([]);
  const [Title, SetTitle] = useState<string>();
  const [Column, setColumn] = useState<any>();
  const [load, setLoad] = useState(false);

  useEffect(() => {
    GetStatOfBranch(true);
  }, []);

  // Définition des colonnes avec les badges
  const columns: ColumnsType<DatatEod> = [
    { title: 'Agence', dataIndex: 'codage', width: 80 },
    { title: 'Statut', dataIndex: 'cdetat', align: 'center', width: 80, 
      render: (val) => <BranchStatusBadge status={val} /> 
    },
    { title: 'Date Veille', dataIndex: 'datVeil', width: 90 },
    { title: 'Date Jour', dataIndex: 'datJour', width: 90 },
    { title: 'Caisse', dataIndex: 'cdetatCai', align: 'center', width: 80, 
      render: (val, record: any) => (
        <CaisseStatusBadge 
          status={val} 
          disabled={!(val === "50" || !loadP)} 
          onClick={() => { SetOpen(true); GetDetailEod(record.codage, 1); }} 
        />
      )
    },
    { title: 'Litiges N.V.', align: 'center', width: 90, 
      render: (_, record: any) => (
        <IndicatorBadge 
          count={record.nbrLitigeNonVal} 
          disabled={record.nbrLitigeNonVal === 0 || loadP} 
          onClick={() => { SetOpen(true); GetDetailEod(record.codage, 2); }} 
        />
      )
    },
    { title: 'Litiges N.C.', align: 'center', width: 90, 
      render: (_, record: any) => (
        <IndicatorBadge 
          count={record.nbrLitigeNonConf} 
          disabled={record.nbrLitigeNonConf === 0 || loadP} 
          onClick={() => { SetOpen(true); GetDetailEod(record.codage, 3); }} 
        />
      )
    },
    { title: 'B.O Équi. N.V.', align: 'center', width: 100, 
      render: (_, record: any) => (
        <IndicatorBadge 
          count={record.nbrRefEquiNonValEcpT} 
          disabled={record.nbrRefEquiNonValEcpT === 0 || loadP} 
          onClick={() => { SetOpen(true); GetDetailEod(record.codage, 4); }} 
        />
      )
    },
    { title: 'B.O Déséq. N.V.', align: 'center', width: 100, 
      render: (_, record: any) => (
        <IndicatorBadge 
          count={record.nbrRefDeseqNonValEcpT} 
          disabled={record.nbrRefDeseqNonValEcpT === 0 || loadP} 
          onClick={() => { SetOpen(true); GetDetailEod(record.codage, 5); }} 
        />
      )
    },
    { title: 'B.O Val. Déséq.', align: 'center', width: 100, 
      render: (_, record: any) => (
        <IndicatorBadge 
          count={record.nbrRefDeseqEcp} 
          disabled={record.nbrRefDeseqEcp === 0 || loadP} 
          onClick={() => { SetOpen(true); GetDetailEod(record.codage, 6); }} 
        />
      )
    }
  ];

  // === Colonnes pour les modales (inchangées) ===
  const ColumCaisse: ColumnsType<CaisseEOD> = [
    {
      title: 'Caisse',
      dataIndex: 'NODECE',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Status',
      align: 'center',
      dataIndex: 'CDETAT',
      ellipsis: true,
      width: 100,
      render: (text: any, record: any) => (
        <Box sx={{ alignItems: 'center' }} gap={'1em'} >
          <Badge status='success' color={record.CDETAT == "51" ? '#116599' : record.CDETAT == "50" ? 'red' : 'orange'} size='default' count={record.CDETAT == "50" ? 'Open' : record.CDETAT == "51" ? 'Closed' : 'Enclose'}> </Badge>
        </Box>
      )
    },
    {
      title: 'Instituler',
      ellipsis: true,
      width: 200,
      dataIndex: 'LECEON',
    },
    {
      title: 'Utilisateur',
      dataIndex: 'CAIUTI',
      ellipsis: true,
      width: 100,
    }
  ];

  const columnsOp: ColumnsType<DataHistoCpt> = [
    {
      title: 'DateOpe',
      dataIndex: 'DATOPE',
      ellipsis: true,
      width: 100,
      render: (text: any) => <span>{ReformatDate(text)}</span>
    },
    {
      title: 'Référence',
      dataIndex: 'REPECE',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Utisai',
      dataIndex: 'UTISAI',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Total débit',
      dataIndex: 'total_debit',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Total crédit',
      dataIndex: 'total_credit',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Total Ecart',
      dataIndex: 'ecart',
      ellipsis: true,
      width: 150,
    }
  ];

  const columnLitige: ColumnsType<any> = [
    { title: 'Référence', dataIndex: 'NUMRAP' },
    { title: 'Compte', dataIndex: 'NODUCP' },
    { title: 'Date', dataIndex: 'DATECR' },
    { title: 'Remettant', dataIndex: 'REMETT' },
    { title: 'CNI Remettant', dataIndex: 'cniremet' },
    { title: 'Montant', dataIndex: 'MONTAN' },
    { title: "Solde AO", dataIndex: 'soldeApreOpe' }
  ];

  // === Fonctions métier (inchangées) ===
  const ProcesComptabilisationEOD = () => {
    setLoadP(true);
    if (AgenceC.length > 0) {
      SweetAlert.fire({
        title: "Voulez vous clôturer les agences ?",
        text: JSON.stringify(AgenceC).replace("[\"", '').replace("\"]", '').replaceAll("\"", ''),
        showCancelButton: true,
        color: "#116599",
        confirmButtonText: "Yes",
        confirmButtonColor: "#116599",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          let init = 100 / AgenceC.length;
          AgenceC.forEach(async (Agence: string) => {
            await axios({
              method: 'post',
              maxBodyLength: Infinity,
              url: Data.ApiUrl.CloseDayEOD,
              headers: {
                'Content-Type': 'application/json',
                'Authorization': authHeader(),
                'CypherCodu': Crypter.encrypt(user.coduti),
                'CypherAgence': Crypter.encrypt(Agence)
              }
            })
              .then((response) => {
                if (response.data) {
                  const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                  if (res.StatutCode == 200) {
                    toast.success(res.Result);
                    if (AgenceC.find((value) => value == AgenceC[0]) == AgenceC[0]) setProgress(init);
                    else setProgress(progress + init);
                  } else {
                    toast.error(res.Result);
                    SweetAlert.fire({ title: res.Message, text: res.Result, icon: "error" });
                  }
                }
              }).catch((error) => {
                console.log(error);
                setLoadP(false);
                SweetAlert.fire({ title: "Error", text: error.message, icon: "error" });
              });
            GetStatOfBranch(false);
            setLoadP(false);
            setSelectedRowKeys([]);
          });
        } else { setLoadP(false); }
      });
    } else {
      SweetAlert.fire({ title: "Error", text: "Veuillez sélectionner les Agences ou actualiser la page", icon: "error" });
      setLoadP(false);
    }
  };

  const GetDetailEod = async (Agence: string, Option: number) => {
    Setdata([]);
    setLoad(true);

    let OptionSe: number = Option;
    if (OptionSe === 5 || OptionSe === 6) OptionSe = 4;

    switch (Option) {
      case 1:
        SetTitle("Etat Caisse");
        setColumn(ColumCaisse);
        break;
      case 2:
        SetTitle("Litiges non validés");
        setColumn(columnLitige);
        break;
      case 3:
        SetTitle("Litiges non confirmés");
        setColumn(columnLitige);
        break;
      case 4:
        setColumn(columnsOp);
        SetTitle("BackOffice équilibré non validé");
        break;
      case 5:
        setColumn(columnsOp);
        SetTitle("BackOffice déséquilibrée non validé");
        break;
      case 6:
        setColumn(columnsOp);
        SetTitle("BackOffice déséquilibrée validé");
        break;
    }

    let datat: any[] = [];
    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.GetDetailEod,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherCodu': Crypter.encrypt(user.coduti),
        'CypherAgence': Crypter.encrypt(Agence),
        'CypherOption': Crypter.encrypt(Option.toString()),
      }
    };

    await axios(config)
      .then((response) => {
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          if (res.StatutCode == 200) {
            let datas = res.Result;
            if (datas.length !== 0) {
              switch (OptionSe) {
                case 1:
                  datas.map((data: any) => {
                    datat.push({
                      NODECE: data.NODECE,
                      LECEON: data.LECEON,
                      CAIUTI: data.NMURCR + " -- " + data.CAIUTI,
                      CDETAT: data.CDETAT
                    });
                  });
                  Setdata(datat);
                  break;
                case 2:
                case 3:
                  datas.map((data: any, indice: number) => {
                    datat.push({ key: indice, ...data });
                  });
                  Setdata(datat);
                  break;
                case 4:
                  datas.map((data: any, indice: number) => {
                    datat.push({
                      key: indice,
                      NUMCPT: data.NODUCP,
                      DATOPE: (new Date(data.DATOPE.substring(0, 10))).toLocaleDateString("fr"),
                      TIME: data.TIME ? data.TIME.substring(11,) : '',
                      SENSEC: data.SENSEC,
                      REPECE: data.REPECE,
                      NUMRAP: data.NUMRAP,
                      LIBELL: data.LIBELL,
                      MONTANT: formatNumber(data.MONTAN ? data.MONTAN : ''),
                      NBENEF: data.NBENEF,
                      UTISAI: data.UTISAI,
                      CODOPE: data.CDLBEC,
                      NLIGNE: data.NLIGNE,
                      NOMCPT: data.NOMCPT,
                      total_debit: formatNumber(data.total_debit),
                      total_credit: formatNumber(data.total_credit),
                      ecart: formatNumber(data.ecart),
                      RelObject: data
                    });
                  });
                  Setdata(datat);
                  break;
                default: break;
              }
            }
          }
        }
        setLoad(false);
      }).catch((error) => {
        console.log(error);
        setLoad(false);
        SetOpen(false);
        SweetAlert.fire({ title: "Error", text: error.message, icon: "error" });
      });
  };

  const GetStatOfBranch = async (load: boolean) => {
    setDatatEod([]);
    setSelectedRowKeys([]);
    setLoading1(load);
    let datat: DatatEod[] = [];

    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.GetBranchStatus,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherCodu': Crypter.encrypt(user.coduti),
        'CypherAgence': Crypter.encrypt(user.codage),
        'CypherCodeProcess': Crypter.encrypt('EOD')
      }
    };

    await axios(config)
      .then((response) => {
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          if (res.StatutCode == 200) {
            let datas = res.Result.Table;
            if (datas.length !== 0) {
              datas.map((data: any, indice: number) => {
                datat.push({
                  key: indice,
                  codage: data.codage,
                  datVeil: (new Date(data.datVeil.substring(0, 10))).toLocaleDateString("fr"),
                  datJour: (new Date(data.datJour.substring(0, 10))).toLocaleDateString("fr"),
                  cdetat: data.cdetat,
                  cdetatCai: data.cdetatCai,
                  nbrLitigeNonVal: data.nbrLitigeNonVal,
                  nbrLitigeNonConf: data.nbrLitigeNonConf,
                  nbrRefEquiNonValEcpT: data.nbrRefEquiNonValEcpT,
                  nbrRefDeseqNonValEcpT: data.nbrRefDeseqNonValEcpT,
                  nbrRefDeseqEcp: data.nbrRefDeseqEcp
                });
              });
              setDatatEod(datat);
            }
          } else {
            SweetAlert.fire({ title: res.Message, text: res.Result, icon: "error" });
          }
        }
        setLoading1(false);
      }).catch((error) => {
        console.log(error);
        setLoading1(false);
        SweetAlert.fire({ title: "Error", text: error.message, icon: "error" });
      });
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
    SetAgenceC([]);
    let datat: string[] = [];
    newSelectedRowKeys.map((index: any) => {
      datat.push(DatatEod[index].codage);
    });
    SetAgenceC(datat);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record: DatatEod) => ({
      disabled: !(record.cdetatCai === '53' && record.cdetat === '50' && !loadP)
    }),
  };

  // === Rendu principal ===
  return (
    <DashboardContainer>
      <ToastContainer />
      <DashboardHeader 
        pageTitle={`Fermeture de Journée - Situation au ${user.datjour}`} 
        breadcrumbTitle="Fermeture de journée" 
      />
      
      <StatisticsCards data={DatatEod} />
      
      <ActionBar 
        showSearch={false}
        onExecute={ProcesComptabilisationEOD}
        isActionDisabled={selectedRowKeys.length === 0}
        isLoading={loadP}
        actionText="Exécuter la Clôture (EOD)"
      />

      <AgencyTable 
        loading={loading1} 
        dataSource={DatatEod} 
        columns={columns} 
        rowSelection={rowSelection} 
        progressValue={progress}
        isProcessing={loadP}
      />

      <DetailsModal 
        open={Open} 
        title={Title} 
        loading={load} 
        onClose={() => SetOpen(false)} 
        columns={Column} 
        dataSource={data} 
      />
    </DashboardContainer>
  );
};

export default FermetureJournee;